if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', function () {
		initLicenseActivationForm();
	});
} else {
	initLicenseActivationForm();
}

function initLicenseActivationForm() {
	const form = document.getElementById('licenseActivationForm')
	form.onsubmit = licenseActivationSubmitted.bind(form);

	/**
	 *
	 * @param event
	 */
	function licenseActivationSubmitted(event){
		event.preventDefault();
		const url = this.getAttribute("action");
		document.getElementById('licenseActivationLoadingOverlay').style.display = "flex";
		fetch(url, { method: 'POST',body: new FormData(this) })
			.then(response => response.json())
			.then(result => {
				if(result.activationResult){
					showActivationKey(result.activationResult);
				} else{
					if (Array.isArray(result)) {
						result.forEach((res) => {
							showGlobalError(res.message);
						});
					} else {
						showGlobalError(result.message);
					}

				}
			})
			.catch(errorMsg => {
				console.log(errorMsg);
				showGlobalError('Something went wrong processing your request. Please reload the page and contact the customer support if the problem persists.')
			});
	}

	/**
	 * Show an error message above the manual activation form
	 * @param message
	 */
	function showGlobalError(message){
		document.getElementById('licenseActivationErrors').innerText = message;
		document.getElementById('licenseActivationErrors').style.display = "block"
		document.getElementById('licenseActivationLoadingOverlay').style.display = "none"
		document.querySelectorAll('#licenseActivationForm input ').forEach(item => {
			item.addEventListener('focus', hideGlobalError)
		});
	}
	function hideGlobalError(){
		document.getElementById('licenseActivationErrors').style.display = "none"
		document.querySelectorAll('#licenseActivationForm input ').forEach(item => {
			item.removeEventListener('focus', hideGlobalError)
		});
	}

	/**
	 * Show the activation Key, add functionality to the download and copy buttons
	 * @param result
	 */
	function showActivationKey(result){
		document.getElementById("licenseActivationResultID").textContent = result;
		document.getElementById("licenseActivationResult").style.display = "block";
		document.getElementById("licenseActivationForm").style.display = "none";
		if(document.getElementById("licenseActivationDownload")){
			const blob = new Blob([result], {type: "application/dat"});
			const url = URL.createObjectURL(blob);
			document.getElementById("licenseActivationDownload").setAttribute('href', url);
			document.getElementById("licenseActivationDownload").setAttribute('download', 'activation.dat');
		}


		document.getElementById("licenseActivationCopy").addEventListener('click', event => {
			event.preventDefault();
			let range = document.createRange();
			range.selectNode(document.getElementById("licenseActivationResultID"));
			window.getSelection().removeAllRanges();
			window.getSelection().addRange(range);
			document.execCommand("copy");
			document.getElementById("licenseActivationResultID").focus();
		});
	}

}
